<template>
  <VCard
    flat
    class="d-flex flex-column justify-center align-center grey lighten-4 fill-height pt-6 pt-lg-9 pb-6 pb-lg-9 px-2" width="100%"
  >
    <img
      src="../../assets/img/interview/mic.svg"
    >
    <div class="body-1 text-center mt-4" style="width: 240px">
      {{ $t(`${interviewType}InterviewNotPassed`) }}
    </div>
  </VCard>
</template>

<script>
export default {
  name: 'CandidateInterviewBlank',
  props: {
    interviewType: {
      type: String,
      required: true,
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  onlineInterviewNotPassed: The candidate has not yet completed an online interview
  offlineInterviewNotPassed: The candidate has not yet completed an in-person interview
</i18n>

<i18n locale="ru" lang="yaml">
  onlineInterviewNotPassed: Кандидат пока не прошёл онлайн-интервью
  offlineInterviewNotPassed: Кандидат пока не прошёл очное интервью
</i18n>
